export const ENGRAVING_INSOLE_MESH_NAMES = {
  superrev: {
    left: "mesh_0",
    right: "mesh_0",
  },
  superrev_elite: {
    left: "mesh_1",
    right: "mesh_0",
  },
};
